import type { PageCandidate, PagePairsResponse } from "../../../shared/types";

/** The pages a room has made, oldest first. A first pair is two pages; a page made on request is one. */
export function pagesOf(pairs: PagePairsResponse["pairs"]): PageCandidate[] {
  return pairs.flatMap((p) => [p.a, p.b].filter((c): c is PageCandidate => !!c));
}
